import {searchReturnPurchaseTransactionsReport} from "../../../serviceBroker/transationReportApiServiceBroker";
import React, {FC} from "react";
import {DailyTransactionTypeEnum, PageEnum, TransactionReportSearchParamsModel} from "../../../models";
import {ReportPage, ReportTransactionSearchPanel} from "../../../components";
import {getPageNameByPageId, getSystemLanguageId} from "../../../utils";

export const ReportReturnPurchaseTransactions: FC = () => {
    const initialState: TransactionReportSearchParamsModel = {
        Lang: getSystemLanguageId(),
        lang: getSystemLanguageId(),
        transactionType:DailyTransactionTypeEnum.PurchasesRefund
    };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReturnPurchaseTransactionsReport}
            searchHeader={getPageNameByPageId(PageEnum.ReportReturnPurchases)}
            SearchPanel={ReportTransactionSearchPanel}
            formId={PageEnum.ReportReturnPurchases}
        />
    );
};
